/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Directive, OnInit, ViewChild } from '@angular/core';
import { CdkPortal } from '@angular/cdk/portal';

@Directive()
// tslint:disable-next-line:no-shadowed-variable directive-class-suffix
export abstract class AbstractBlock<AbstractEntityBlock> implements OnInit {
  block: AbstractEntityBlock;
  @ViewChild(CdkPortal, { static: true }) private portal: CdkPortal;

  ngOnInit(): void {
    // if (!this.portal) {
    //   throw new Error(`Each element should have an options' portal, add *cdkPortal inside of HTML block.`);
    // }
  }
}

export abstract class AbstractEntityBlock {}
